module.exports = {
  "version": "0.27.2"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/env/data.js
 ** module id = ./node_modules/axios/lib/env/data.js
 ** module chunks = 0
 **/